<template>
  <div class="accordion scrollable" id="therapiesAccordion">
    <div :key="guest.id" v-for="(guest, index) in guests" class="accordion-group">
      <div :class="['accordion-heading', 'somm--collapse-guest', alertSommClass(guest)]">
        <a
          class="accordion-toggle"
          data-toggle="collapse"
          data-parent="#therapiesAccordion"
          :href="`#collapseGuestTherapy${guest.id}`"
          @click="() => loadTherapy(guest)"
        >
          <slot v-bind="guest"></slot>
        </a>
      </div>
      <div :id="`collapseGuestTherapy${guest.id}`" :class="['accordion-body', 'collapse', { in: index === 0 }]">
        <div class="accordion-inner center">
          <slot v-if="selected === guest" name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'collapsePreparations',
  props: ['guests', 'selected'],
  methods: {
    loadTherapy(guest) {
      this.$parent.$emit('guestSelected', guest);
    },
    alertSommClass(guest) {
      // all_drugs == 0 => terapia AB
      if (!guest.all_drugs || guest.all_drugs === 0) return '';
      if (guest.done_drugs == guest.all_drugs) return 'all_done';
      if (guest.done_with_variations > 0 || guest.all_drugs - guest.done_drugs < guest.all_drugs) return 'some_done';
      return 'none_done';
    },
  },
  mounted() {
    eventBus.$on('toggleAlertTherapy', (guest_period_data_set_id, done, doneWithVariations) => {
      let guest = this.guests.find((item) => item.id === guest_period_data_set_id),
        index = this.guests.indexOf(guest);
      guest['done_drugs'] = done;
      guest['done_with_variations'] = doneWithVariations;
      this.$set(this.guests, index, guest);
    });
  },
};
</script>
<style lang="scss" scoped>
.scrollable {
  max-height: 600px;
  overflow-y: scroll;
}
#tab-somministrations {
  width: 250px;
}
.accordion-inner {
  padding: 0;
}
div.somm--collapse-guest {
  border-radius: 5px 0 0 5px;
  & > a {
    padding: 6px 8px;
  }
  &.all_done {
    border-left: 5px solid #0b0;
  }
  &.none_done {
    border-left: 5px solid red;
  }
  &.some_done {
    border-left: 5px solid orange;
  }
}
</style>
